import Vue from 'vue'
import Router from 'vue-router'
import { requireAuth, requireUnauth, logout, requireCheckInAuth } from '@/library/router-middleware'
const Home = () => import(/* webpackChunkName: "event" */ './views/Home.vue')
const Event = () => import(/* webpackChunkName: "event" */ './views/Event.vue')
const EventDetail = () => import(/* webpackChunkName: "event" */ './views/EventDetail.vue')
const Product = () => import(/* webpackChunkName: "event" */ './views/Product.vue')
const Coupon = () => import(/* webpackChunkName: "event" */ './views/Coupon.vue')
const Login = () => import(/* webpackChunkName: "event" */ './views/Login.vue')
const PaymentSetting = () => import(/* webpackChunkName: "event" */ './views/PaymentSetting.vue')
const BankSetting = () => import(/* webpackChunkName: "event" */ './views/BankSetting.vue')
const BasicSetting = () => import(/* webpackChunkName: "event" */ './views/BasicSetting.vue')
const EmailCompose = () => import(/* webpackChunkName: "event" */ './views/basic-setting/EmailCompose.vue')
const SetLanding = () => import(/* webpackChunkName: "event" */ './views/SetLanding.vue')
const FormIntegration = () => import(/* webpackChunkName: "event" */ './views/FormIntegration.vue')
const CheckIn = () => import(/* webpackChunkName: "event" */ './views/CheckIn.vue')
const CheckInGuest = () => import(/* webpackChunkName: "event" */ './views/CheckInGuest.vue')
const RegistrantReport = () => import(/* webpackChunkName: "event" */ './views/RegistrantReport.vue')
// const ExhibitorReport = () => import(/* webpackChunkName: "event" */ './views/ExhibitorReport.vue')
const RegistrantDetail = () => import(/* webpackChunkName: "event" */ './views/RegistrantDetail.vue')
const AttendeeDetail = () => import(/* webpackChunkName: "event" */ './views/AttendeeDetail.vue')
const PageNotFound = () => import(/* webpackChunkName: "event" */ './views/PageNotFound.vue')
const ComposerApp = () => import(/* webpackChunkName: "composer-app" */ './views/ComposerApp.vue')
const PrintIDCard = () => import(/* webpackChunkName: "composer-app" */ './views/PrintIDCard.vue')
const AllReport = () => import(/* webpackChunkName: "event" */ './views/AllReport.vue')
const AllReportDetail = () => import(/* webpackChunkName: "event" */ './views/AllReportDetail.vue')

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      beforeEnter (to, from, next) {
        next('/event')
      }
    },
    {
      path: '/dash',
      name: 'dashboard',
      component: Home,
      beforeEnter (to, from, next) {
        next('/event')
      }
    },
    {
      path: '/event',
      name: 'event',
      component: Event,
      beforeEnter: requireAuth
    },
    {
      path: '/event/:id',
      name: 'event-detail',
      component: EventDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/product/:id',
      name: 'event-product',
      component: Product,
      beforeEnter: requireAuth
    },
    {
      path: '/coupon/:id',
      name: 'event-coupon',
      component: Coupon,
      beforeEnter: requireAuth
    },
    {
      path: '/setting/payment/:id',
      name: 'event-setting-payment',
      component: PaymentSetting,
      beforeEnter: requireAuth
    },
    {
      path: '/setting/bank/:id',
      name: 'event-setting-bank',
      component: BankSetting,
      beforeEnter: requireAuth
    },
    {
      path: '/setting/basic/:id',
      name: 'event-setting-basic',
      component: BasicSetting,
      beforeEnter: requireAuth
    },
    {
      path: '/setting/basic/:id/:type',
      name: 'event-email-setting-compose',
      component: EmailCompose,
      beforeEnter: requireAuth
    },
    {
      path: '/event-landing/:id',
      name: 'event-landing',
      component: SetLanding,
      beforeEnter: requireAuth
    },
    {
      path: '/event-form/:id',
      name: 'event-form',
      component: FormIntegration,
      beforeEnter: requireAuth
    },
    {
      path: '/all-report/:id',
      name: 'all-event-report',
      component: AllReport,
      beforeEnter: requireAuth
    },
    {
      path: '/all-report/:id/event-visit/',
      name: 'event-visit-report',
      component: AllReportDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/all-report/:id/room-visit',
      name: 'room-visit-report',
      component: AllReportDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/all-report/:id/room-visit-visitor/:roomId',
      name: 'room-visit-visitor-report',
      component: AllReportDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/all-report/:id/exhibitor-visit',
      name: 'exhibitor-visit-report',
      component: AllReportDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/all-report/:id/exhibitor-visit-visitor/:boothId',
      name: 'exhibitor-visit-visitor-report',
      component: AllReportDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/report/:id',
      name: 'event-report',
      component: RegistrantReport,
      beforeEnter: requireAuth
    },
    {
      path: '/report/:id/:registrantId',
      name: 'event-report-registrant-detail',
      component: RegistrantDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/report-attendee/:id',
      name: 'event-report-attendee',
      component: RegistrantReport,
      beforeEnter: requireAuth
    },
    {
      path: '/report-attendee/:id/:attendeeId',
      name: 'event-report-attendee-detail',
      component: AttendeeDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/report-exhibitor/:id',
      // path: '/report-exhibitor',
      name: 'event-report-exhibitor',
      component: RegistrantReport,
      beforeEnter: requireAuth
    },
    {
      path: '/report-exhibitor/:id/:exhibitorId',
      name: 'event-report-exhibitor-detail',
      component: AttendeeDetail,
      beforeEnter: requireAuth
    },
    {
      path: '/report-confirm/:id',
      name: 'event-report-confirm-payment',
      component: RegistrantReport,
      beforeEnter: requireAuth
    },
    {
      path: '/composer-app/:id/:type',
      name: 'composer-app',
      component: ComposerApp,
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      beforeEnter: requireUnauth
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: logout
    },
    {
      path: '/checkin/:billingId',
      name: 'checkin',
      component: CheckInGuest,
      beforeEnter: requireCheckInAuth
    },
    {
      path: '/checkin-in/:billingId',
      name: 'checkin-in',
      component: CheckIn,
      beforeEnter: requireAuth
    },
    {
      path: '/print/id-card/:attendeeId',
      name: 'print-id-card',
      component: PrintIDCard,
      beforeEnter: requireAuth
    },
    {
      path: '/print/id-card',
      name: 'print-all-id-card',
      component: PrintIDCard,
      beforeEnter: requireAuth
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound,
    }
  ]
})
